export default __webpack_public_path__ + "static/highlight-motion-5877ca67a476341f1e146a27d185e5aa.png";